module.exports = __webpack_public_path__ + "static/media/student-summary-bottom2.4b014024.png";